import { initImage } from 'globalCommon/utils/index';
import commonPageService from 'pcCommon/services/commonPageService';
import { IMG_SOURCE } from './imagesSource';
import { syncRender } from 'globalCommon/services/syncRender';
import './style.css';
import './reset.css';

const init = () => {
    commonPageService({ renderAfter: syncRender });
    initImage(IMG_SOURCE);
};

init();
